import { compose, createStore, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware, { END } from 'redux-saga';
import createRootReducer from './reducers';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const sagaMiddleware = createSagaMiddleware()

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'] // only auth will be persisted
  }


const configureStore = (initialState = {}, history) => {
    const persistedReducer = persistReducer(persistConfig, createRootReducer(history));

    const composeEnhancers = process.env.NODE_ENV !== 'production'
    && typeof window === 'object'
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            shouldHotReload: false,
        })
        : compose

    const middlewares = [
        sagaMiddleware,
        routerMiddleware(history)
    ]

    const enhancers = [
        applyMiddleware(...middlewares),
    ]

    const store = createStore(
        persistedReducer,
        composeEnhancers(...enhancers),
    )

    store.runSaga = sagaMiddleware.run
    store.asyncReducers = {}
    store.close = () => store.dispatch(END)

    if (module.hot) {
        // Enable webpack hot module replacement for reducers
        module.hot.accept(
            './reducers',
            () => {
                import('./reducers').then(reducerModule => {
                    const createReducers = reducerModule.default
                    const nextReducers = createReducers(store.asyncReducers)
                    store.replaceReducer(nextReducers)
                })
            },
        )
    }

    return store
}

const initialState = {};
const history = createBrowserHistory();

export default () => {
    let store = configureStore(initialState, history);
    let persistor = persistStore(store)
    return { store, persistor }
  }
